var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"md-button",class:[
    _vm.type,
    _vm.inactive ? 'inactive' : 'active',
    _vm.inline ? 'inline' : 'block',
    _vm.round ? 'round' : '',
    _vm.plain ? 'plain' : '',
    _vm.size === 'small' ? 'small' : ''
  ],attrs:{"type":_vm.nativeType,"disabled":_vm.inactive || _vm.type === 'disabled'}},_vm.$listeners),[_c('div',{staticClass:"md-button-inner"},[(_vm.loading)?[_c('md-activity-indicator-rolling',{staticClass:"md-button-loading"})]:(_vm.icon)?[_c('md-icon',{attrs:{"name":_vm.icon,"svg":_vm.iconSvg}})]:_vm._e(),_c('div',{staticClass:"md-button-content"},[_vm._t("default")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }